export const format = (num: number, decimals: number) =>
  num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export const toEsDate = ( date: string)=>{
  const options:any = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(date).toLocaleDateString('es-EN', options)
}